import React from 'react'
import { Route, Switch } from 'react-router'
import ReportCustomerWeeklyPlans from './ReportCustomerWeeklyPlans'

const Components = props => (
    <Switch>
        <Route exact path={props.match.url} component={ReportCustomerWeeklyPlans} />
    </Switch>
)

export default Components
